import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import { merchantCardSummayDetail } from "../components/utils/models/merchantCardSummaryDetail";
import { MerchantGridRecord } from "../components/utils/models/MerchantGridRecord";
import { EnvironmentService } from "./environment.service";


@Injectable()
export class MerchantService{

    constructor(private http: HttpClient, private environmentService: EnvironmentService) { }

    getCardValues() : Observable<merchantCardSummayDetail[]>
    {
        return this.http.get<merchantCardSummayDetail[]>(`${this.environmentService.getConfig('BackendApi')}api/Merchants/GetMerchantCardValues`);
    }


    getPagedMerchantDetails(page: number, pageSize: number,filter? : string): Observable<{ data: MerchantGridRecord[], totalRecords: number ,summary : number[] }> {
        let params = new HttpParams()
          .set('PageNumber', page.toString())
          .set('PageSize', pageSize.toString());

          if(filter){
            params = params
            .set('$filter',filter.toString());
          }
    
        return this.http.get<{ data: MerchantGridRecord[], totalRecords: number, summary : number[] }>(`${this.environmentService.getConfig('BackendApi')}odata/LedgerTransactions`, { params });
    }
}
